import { get } from 'lodash';
import { canPayBeneficiaries } from '../accounts/selectors';

export const getSelectedPaymentId = (state) => get(state, 'payeeSelector.selectedPaymentId', '');
export const getSelectedFromAccount = (state) => get(state, 'payeeSelector.selectedFromAccount', '');
export const getSelectedFromAccountDetails = (state) => get(state, 'payeeSelector.selectedFromAccountDetails');

export const getFromAccountCanPayBenificiaries = (state) => {
	const fromAccount = getSelectedFromAccount(state);
	return canPayBeneficiaries(state, fromAccount);
};
